import React from "react";
import { Link } from "react-router-dom";
import { appHistory } from "@/router/history";
import { compose } from "helper/compose";
import { withTranslation, type WithTranslation } from "react-i18next";

import BorrowCustomerForm from "./BorrowCustomerForm";
import { withAuthData, type AuthInjectedProps } from "../../context/AuthContext";

const BorrowCustomerFormAny = BorrowCustomerForm as unknown as React.ComponentType<
  Record<string, unknown>
>;

interface BorrowCustomerPageOwnProps extends WithTranslation {
  params: { token?: string };
}

type BorrowCustomerPageProps = BorrowCustomerPageOwnProps & AuthInjectedProps;

function BorrowCustomerPage({
  t,
  params,
  userLoggedIn,
  adminToken,
  actions,
  borrowCustomerPageMessage,
}: BorrowCustomerPageProps) {
  const [customerCode, setCustomerCode] = React.useState("");
  const [isAuthenticating, setIsAuthenticating] = React.useState(false);

  React.useEffect(() => {
    if (params.token) {
      actions.saveAdminToken(params.token);
      void actions.checkAdminToken(params.token);
      return;
    }

    if (userLoggedIn) {
      appHistory.push(BASE_PATH + "/");
      return;
    }

    const token = params.token || (adminToken as string | null | undefined);
    if (!token) {
      appHistory.push(BASE_PATH + "/login");
      return;
    }

    actions.checkAdminToken(token as string);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onCustomerCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCustomerCode(event.target.value);
  };

  const onFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (customerCode !== "" && !isAuthenticating) {
      setIsAuthenticating(true);
      void actions.borrowCustomer(customerCode).finally(() => setIsAuthenticating(false));
    }
  };

  if (!userLoggedIn && adminToken) {
    return (
      <div className="Page AuthPage BorrowCustomerPageShell">
        <div className="Page-content">
          <div className="AuthPage-header">
            <div className="LogoCompanyWrapper">
              <Link to={BASE_PATH + "/"}>
                <div className="LogoCompany isGMC"></div>
              </Link>
            </div>
            <p className="AuthPage-kicker">{t("topbar.platform_label")}</p>
            <h2 className="Page-title isSpaced">{t("login.label_connect_to_customer_account")}</h2>
          </div>
          <BorrowCustomerFormAny
            message={borrowCustomerPageMessage}
            onCustomerCodeChange={onCustomerCodeChange}
            onSubmit={onFormSubmit}
            isAuthenticating={isAuthenticating}
          />
          <a href={BACK_URL} className="Button DashboardFeatureCard-button">
            {t("login.label_back_admin")}
          </a>
        </div>
      </div>
    );
  }
  return null;
}

export default compose(withTranslation(), withAuthData)(BorrowCustomerPage);
